/**
 * viewport.js
 * ───────────
 * Shared reactive viewport state for the public Website SPA.
 * `window.innerWidth` read directly inside computed properties is NOT
 * reactive — components using it freeze at their first-render width.
 * Import this observable instead: any computed referencing
 * `viewport.width` re-evaluates on window resize.
 */
import Vue from 'vue';
import visitor from './visitor.js';
import { audienceAllows } from '@/websites/cms/blocks/shared/audienceRules.js';

var MOBILE_BREAKPOINT = 768;

var viewport = Vue.observable({
	width: typeof window !== 'undefined' ? window.innerWidth : 1200
});

if (typeof window !== 'undefined') {
	var resizeTimer = null;
	window.addEventListener('resize', function () {
		if (resizeTimer) return;
		resizeTimer = setTimeout(function () {
			resizeTimer = null;
			viewport.width = window.innerWidth;
		}, 100);
	});
}

export default viewport;

export function isMobileViewport() {
	return viewport.width < MOBILE_BREAKPOINT;
}

/**
 * Shared visibility check for a block's visibility trait: the device rule
 * ('always' | 'desktopOnly' | 'mobileOnly', legacy `props.visibility`
 * accepted) and the audience rules (`style.audience`: signed in, members,
 * newsletter subscribers, audiences). Reactive to resizes and to sign-in.
 */
export function isBlockVisible(block) {
	var vis = (block && block.style && block.style.visibility)
		|| (block && block.props && block.props.visibility)
		|| 'always';
	if (vis === 'desktopOnly' && isMobileViewport()) return false;
	if (vis === 'mobileOnly' && !isMobileViewport()) return false;
	var audience = block && block.style && block.style.audience;
	if (audience && !audienceAllows(audience, visitor)) return false;
	return true;
}
